import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  font-family: var(--main-font);
  margin-left: 32px;
  grid-row-gap: 32px;
  padding-bottom: 44px;
`;

export const SectionWrapper = styled.div`
  h1 {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    margin: 0;
  }
`;

export const LinksWrapper = styled.div`
  display: grid;
  margin: 12px 0 0 22px;

  a {
    width: max-content;
    font-family: var(--main-font);
    font-size: 14px;
    line-height: 24px;
    opacity: 0.6;
    font-weight: normal;

    &:active,
    &:visited,
    &:link,
    &:focus {
      text-decoration: none;
      color: unset;
      border: none;
    }
    &:hover {
      border: none;
    }
    &.ActiveLink {
      color: var(--brand-blue);
      font-weight: bold;
      opacity: 1;
    }
  }
`;
